export const text = {
  header: "Sorry, this page isn't available.",
  subheader: "The page you are looking for may have moved.",
  button: "GET BACK HOME",
};
